import { submitEvent } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';

export const initGuidelines = (rootElement: Pick<HTMLElement, 'querySelector'>, variationId: string): void => {
    const linkElement = rootElement.querySelector<HTMLOcLinkV2Element>('.js_cr_guidelines__link');
    if (linkElement) {
        registerEventTrackingForGuidelinesLink(linkElement, variationId);
    }
};

const registerEventTrackingForGuidelinesLink = (linkElement: HTMLOcLinkV2Element, variationId: string): void => {
    linkElement?.addEventListener('click', () => {
        submitEvent(
            {
                review_Link: ['Guidelines'],
            },
            {
                name: 'click',
                features: getProductFeaturesForNonPdpPage(variationId),
            }
        );
    });
};
